import Home from './pages/Home';

function App() {
    // return <div className="text-4xl text-red-500 font-black">TAILWIND OK</div>;
    return <Home/>;
}

export default App;
